import { FC, useEffect } from 'react';

import { Box, styled, TextAreaInput, themeGet } from '@qwealth/qcore';

import { selectClientComplianceReview, selectComplianceSelectedChecklistNotes } from 'data/selectors/compliance';
import { setComplianceSelectedChecklistNotes } from 'data/actions/compliance';
import { ClientComplianceReview, ComplianceNote, ComplianceNotesMap } from 'data/models/Compliance';
import { useAppSelector, useAppDispatch } from 'data/store';

const StyledSectionNotesContainer = styled(TextAreaInput)`
  width: 100%;
  min-height: 200px;
  background-color: ${themeGet('colors.white')};
  padding: ${themeGet('space.default')};
  border-radius: ${themeGet('radii.default')};
  color: ${themeGet('colors.dark')};
  font-size: ${themeGet('fontSizes.default')};
  font-weight: ${themeGet('fontWeights.normal')};
`;

interface ChecklistSectionNotesProps {
  sectionId: number;
  sectionTitle: string;
  note: string;
  numNoncompliant: number;
}

const ChecklistSectionNotes: FC<ChecklistSectionNotesProps> = ({ note, sectionTitle, sectionId, numNoncompliant }) => {
  const checklistNotes = useAppSelector(selectComplianceSelectedChecklistNotes);
  const selectedClient: ClientComplianceReview | undefined = useAppSelector(selectClientComplianceReview);
  const dispatch = useAppDispatch();

  const makeNewNote = (noteContent: string): ComplianceNote => {
    return {
      content: noteContent,
      noteType: 'compliance',
      owners: [selectedClient?.QID as string],
      title: sectionTitle,
      itemId: sectionId,
    };
  };

  const updateNotes = (noteContent: string) => {
    let updatedNotes: ComplianceNotesMap = {};

    if (checklistNotes) {
      updatedNotes = JSON.parse(JSON.stringify(checklistNotes));
    }

    if (updatedNotes[sectionId]) {
      updatedNotes[sectionId].content = noteContent;
    } else {
      const newSectionNote = makeNewNote(noteContent);
      updatedNotes[sectionId] = newSectionNote;
    }

    dispatch(setComplianceSelectedChecklistNotes(updatedNotes));
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const noteContent = event.currentTarget.value;
    updateNotes(noteContent);
  };

  useEffect(() => {
    if (numNoncompliant === 0) updateNotes('');
  }, [numNoncompliant]);

  return (
    <>
      {numNoncompliant > 0 && (
        <Box fontWeight="bold">
          Notes:
          <StyledSectionNotesContainer onBlur={e => handleInputChange(e)} defaultValue={note} />
        </Box>
      )}
    </>
  );
};

export default ChecklistSectionNotes;
